"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.projectStreamMinutesSelector = void 0;
const getRecordSelector_1 = __importDefault(require("root/src/client/logic/api/selectors/getRecordSelector"));
const getEndpointDesc_1 = require("root/src/shared/descriptions/getEndpointDesc");
const endpointIds_1 = require("root/src/shared/descriptions/endpoints/endpointIds");
const responseLenses = (0, getEndpointDesc_1.getResponseLenses)(endpointIds_1.GET_PROJECT);
const { viewStreamMinutes } = responseLenses;
const projectStreamMinutesSelector = (state, props) => {
    return viewStreamMinutes((0, getRecordSelector_1.default)(state, props));
};
exports.projectStreamMinutesSelector = projectStreamMinutesSelector;
